import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Features } from '../components/Features';
import { Gallery } from '../components/Gallery';
import { HowItWorks } from '../components/HowItWorks';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    // Page Title
    document.title = 'KKbaby — 新加坡高端伴游服务 | Your Trusted Companion in Singapore';
    // Helper to set or create meta tags
    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    // Basic SEO
    setMeta('description', 'KKbaby — 新加坡高端伴游服务。汇聚来自世界各地的漂亮女孩，真实认证，无定金，见面满意再付款。Your trusted companion service in Singapore with verified profiles, no deposit required.');
    setMeta('keywords', 'KKbaby, 新加坡伴游, Singapore companion, 高端伴游, escort Singapore, 真实认证, verified profiles, no deposit, 无定金, 见面付款');
    setMeta('author', 'KKbaby');
    setMeta('robots', 'index, follow');
    // Language
    document.documentElement.lang = 'zh-CN';
    setMeta('content-language', 'zh-CN, en');
    // Open Graph
    setMeta('og:title', 'KKbaby — 新加坡高端伴游服务 | Trusted Companion in Singapore', true);
    setMeta('og:description', '汇聚来自世界各地的漂亮女孩，真实认证，无定金，见面满意再付款。让每一次相遇，成为难忘的心动旅程。', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://www.geylang777-5.site', true);
    setMeta('og:site_name', 'KKbaby', true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('og:locale:alternate', 'en_US', true);
    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'KKbaby — Your Trusted Companion in Singapore');
    setMeta('twitter:description', '汇聚来自世界各地的漂亮女孩，真实认证，无定金，见面满意再付款。');
  }, []);
  return <main className="min-h-screen bg-[#0A0A0A] text-[#F5F0E8] selection:bg-[#D4AF37] selection:text-black" data-id="element-113">
      <Hero data-id="element-114" />
      <About data-id="element-115" />
      <Features data-id="element-116" />
      <Gallery data-id="element-117" />
      <HowItWorks data-id="element-118" />
      <Footer data-id="element-119" />
    </main>;
}